import React, { useContext, useEffect, useState } from "react";
import InvoiceProductList from "../InvoiceProductList";
import ProductDetailList from "../ProductDetail";
import "./invoice.css";
import { TabTitle } from "../../../../util/titleChanger";
import { GlobalState } from "../../../../GlobalState";
import { api } from "../../../../util/urlConfig";
import { ToastContainer, toast } from "react-toastify";
import { createNewInvoice } from "../../../../action";

export default function Invoice() {
  TabTitle("Invoice");

  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  const [productData, setProductData] = useState([]);
  const [productListData, setProductListData] = useState([]);
  const [addProducts, setAddProducts] = useState([]);

  const [productsList] = state.productAPI.productsList;
  const [newInvNo] = state.invoiceAPI.newInvNo;
  const [callback, setCallback] = state.invoiceAPI.callback;

  const [allCustomers] = state.customerAPI.allCustomers;
  const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
  const [selectCustomer, setSelectCustomer] = useState("");
  const customerSuggestions = allCustomers.filter((customer) => customer.first_name.toString().toLowerCase().includes(selectCustomer.toString().toLowerCase()));

  const [stocks] = state.stockAPI.stocks;

  const [showProductSuggestions, setShowProductSuggestions] = useState(false);
  const [selectProduct, setSelectProduct] = useState("");
  const productSuggestions = productListData.filter((product) => product.name.toString().toLowerCase().includes(selectProduct.toString().toLowerCase()));

  const [values, setValues] = useState([]);
  const [focused, setFocused] = useState(false);

  const handleProductSuggestionClick = (suggestion) => {
    setSelectProduct(suggestion.name);
    setShowProductSuggestions(false);
    setValues({
      ...values,
      productId: suggestion.id,
    });
  };

  const onChangeSelectProduct = (e) => {
    setSelectProduct(e.target.value);
    setProductData(productSuggestions);
  };

  const handleCustomerSuggestionClick = (suggestion) => {
    setSelectCustomer(suggestion.first_name + " " + suggestion.last_name);
    setShowCustomerSuggestions(false);
    setValues({
      ...values,
      customerId: suggestion.id,
    });
  };

  const onChangeSelectCustomer = (e) => {
    setSelectCustomer(e.target.value);
  };

  const handleFocus = (e) => {
    setFocused(false);
  };

  const addProductOnClick = (e, product) => {
    e.preventDefault();

    const filteredStock = stocks.filter((stock) => stock.productId === product.id);

    if (addProducts.length === 0) {
      if (filteredStock[0].qty > 0) {
        setAddProducts([
          ...addProducts,
          {
            id: product.id,
            img: product.upload_image ? api + "/" + product.upload_image.image_url : "/img/dummy_avatar.png",
            name: product.name,
            unit_price: filteredStock[0].unit_selling_price,
            quantity: 1,
            discount: 0,
            total_price: parseFloat(filteredStock[0].unit_selling_price) * 1,
          },
        ]);
      } else {
        toast.warn("Stock Unavailable for this product!");
      }
    } else {
      if (filteredStock[0].qty) {
        if (addProducts.filter((pro) => pro.id === product.id).length === 0) {
          setAddProducts([
            ...addProducts,
            {
              id: product.id,
              img: product.upload_image ? api + "/" + product.upload_image.image_url : "/img/dummy_avatar.png",
              name: product.name,
              unit_price: filteredStock[0].unit_selling_price,
              quantity: 1,
              discount: 0,
              total_price: parseFloat(filteredStock[0].unit_selling_price) * 1,
            },
          ]);
        } else {
          toast.warn("This product already selected!");
        }
      } else {
        toast.warn("Stock Unavailable for this product!");
      }
    }
  };

  const handleRemoveProductClick = (e, index) => {
    e.preventDefault();
    let newIndex = index - 1;
    const list = [...addProducts];
    list.splice(newIndex, 1);
    setAddProducts(list);
  };

  const onCalculateDiscount = (e, product_id) => {
    const { name, value } = e.target;
    setAddProducts(
      addProducts.map((product) =>
        product_id === product.id
          ? {
              ...product,
              discount: value,
              total_price: parseFloat(product.unit_price) * parseFloat(product.quantity) - parseFloat(value),
            }
          : product
      )
    );
  };

  const onCalculateTotal = (amount, qty, product_id) => {
    setAddProducts(
      addProducts.map((product) =>
        product_id === product.id
          ? {
              ...product,
              quantity: qty,
              total_price: parseFloat(amount) * parseFloat(qty),
            }
          : product
      )
    );
  };

  const countTotalDiscount = () => {
    return addProducts.reduce((total, product) => (total = total + parseFloat(product.discount)), 0).toString();
  };

  const countTotalAmount = () => {
    return addProducts.reduce((total, product) => total + parseFloat(product.unit_price) * parseFloat(product.quantity), 0).toString();
  };

  const countNetTotal = () => {
    var totalDiscount = addProducts.reduce((total, product) => (total = total + parseFloat(product.discount)), 0).toString();
    var totalAmount = addProducts.reduce((total, product) => total + parseFloat(product.unit_price) * parseFloat(product.quantity), 0).toString();
    return parseFloat(totalAmount) - parseFloat(totalDiscount);
  };

  useEffect(() => {
    productsList.data ? setProductListData(productsList.data) : setProductListData([]);
  }, [productsList, newInvNo]);

  const getReceiptStyles = () => `
    @page {
      size: 80mm auto;
      margin: 0;
    }
    body {
      width: 80mm !important;
      font-family: 'Courier New', monospace;
      font-size: 12px;
      padding: 5mm;
      background: white;
      color: black;
    }
    .receipt {
      width: 100%;
    }
    .header, .footer {
      text-align: center;
      font-weight: bold;
      margin: 10px 0;
    }
    .divider {
      border-top: 1px dashed #000;
      margin: 5px 0;
    }
    .item-row {
      display: flex;
      justify-content: space-between;
      margin: 3px 0;
    }
    .total {
      font-weight: bold;
    }
  `;

  const generateReceiptHTML = (invoice) => `
    <div class="receipt">
      <div class="header">
        <h3>BUY ME NOW</h3>
        <p>Invoice #${newInvNo}</p>
        <p>Date: ${new Date().toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" })}</p>
        <p>Customer: ${selectCustomer || "Walk-in"}</p>
      </div>
      <div class="divider"></div>
      ${invoice.products
        ?.map(
          (item) => `
        <div class="item-row">
          <span>${item.quantity}x ${item.name}</span>
          <span>Rs ${parseFloat(item.total_price).toFixed(2)}</span>
        </div>`
        )
        .join("")}
      <div class="divider"></div>
      <div class="item-row total">
        <span>TOTAL AMOUNT:</span>
        <span>Rs ${parseFloat(invoice.total_price).toFixed(2)}</span>
      </div>
      <div class="item-row total">
        <span>TOTAL DISCOUNT:</span>
        <span>Rs ${parseFloat(invoice.total_discount).toFixed(2)}</span>
      </div>
      <div class="item-row total">
        <span>TOTAL:</span>
        <span>Rs ${parseFloat(invoice.net_price).toFixed(2)}</span>
      </div>
      <div class="footer">Thank you for shopping!</div>
    </div>
  `;

  const handlePrint = async (invoiceData) => {
    const printContent = `
            <!DOCTYPE html>
            <html>
              <head>
                <title>Invoice #${newInvNo}</title>
                <style>
                  ${getReceiptStyles()}
                </style>
              </head>
              <body>
                <div class="aldi-receipt">
                  ${generateReceiptHTML(invoiceData)}
                </div>
                <script>
                  setTimeout(() => window.print(), 100);
                </script>
              </body>
            </html>
          `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(printContent);
    printWindow.document.close();
  };

  const submitForm = (e) => {
    e.preventDefault();

    const invoiceInfo = {
      quantity: addProducts.reduce((total, product) => (total = total + parseFloat(product.quantity)), 0),
      total_price: countTotalAmount(),
      total_discount: countTotalDiscount(),
      net_price: countNetTotal(),
      updatedBy: signInUser.id,
      createdBy: signInUser.id,
      customerId: values.customerId,
      products: addProducts,
    };

    createNewInvoice(invoiceInfo, (res) => {
      if (res.status === 200) {
        toast.success(res.data);
        //console.log("Invoice products : ", JSON.stringify(invoiceInfo.products));
        handlePrint(invoiceInfo); // Trigger print after successful creation
        setCallback(!callback);
      } else {
        toast.error(res.data);
        setCallback(!callback);
      }
    });
  };

  return (
    <div className="form-container">
      <div className="header">
        <h1>Invoice</h1>
        <div className="custom-input-box">
          <div style={{ width: "70%" }}>
            <label>Customer Name</label>
            <input
              type="text"
              name="search"
              id="search"
              placeholder="Search here...."
              value={selectCustomer}
              onBlur={handleFocus}
              focused={focused.toString()}
              onChange={onChangeSelectCustomer}
              onFocus={() => setShowCustomerSuggestions(true)}
            />
            {showCustomerSuggestions && (
              <ul className="suggestions">
                {customerSuggestions.map((suggestion) => (
                  <li key={suggestion.id} onClick={() => handleCustomerSuggestionClick(suggestion)}>
                    {suggestion.first_name + " " + suggestion.last_name}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div style={{ marginTop: "30px" }}>
            <h3>{newInvNo}</h3>
          </div>
        </div>
      </div>
      <div className="invoice-container">
        <div className="invoice-area">
          <div className="selected-item-list">
            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Image</th>
                  <th>Product Name</th>
                  <th>Qty</th>
                  <th>Unit Price</th>
                  <th>Discount</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>

              {addProducts.map((product, index) => (
                <InvoiceProductList
                  key={index}
                  product={product}
                  index={index + 1}
                  handleRemoveProductClick={handleRemoveProductClick}
                  onCalculateDiscount={onCalculateDiscount}
                  onCalculateTotal={onCalculateTotal}
                />
              ))}
            </table>
          </div>
          <div className="summary-area">
            <div>
              <p>Total : </p>
              <span>Rs. {countTotalAmount()}</span>
            </div>
            <div>
              <p>Discount : </p>
              <span>Rs. {countTotalDiscount()}</span>
            </div>
            <div>
              <p>Net Total : </p>
              <span>Rs. {countNetTotal()}</span>
            </div>
            <div className="btn-checkout">
              <button onClick={(e) => submitForm(e)}>Check Out</button>
            </div>
          </div>
        </div>

        <div className="product-list">
          <div className="search-item">
            <div className="search-box">
              <i className="uil uil-search"></i>
              <input
                type="text"
                name="search"
                id="search"
                placeholder="Search here...."
                value={selectProduct}
                onBlur={handleFocus}
                focused={focused.toString()}
                onChange={onChangeSelectProduct}
                onFocus={() => setShowProductSuggestions(true)}
              />
              {showProductSuggestions && (
                <ul className="suggestions">
                  {productSuggestions.map((suggestion, index) => (
                    <li key={suggestion.id || index} onClick={() => handleProductSuggestionClick(suggestion)}>
                      {suggestion.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="list-product">
            {productSuggestions &&
              productSuggestions.map((product) => (
                <div key={product.id} onClick={(e) => addProductOnClick(e, product)}>
                  <ProductDetailList product={product} />
                </div>
              ))}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
